/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiDetectionResultFromJSON, StreemApiDetectionResultToJSON, } from './';
export function StreemApiRunImageDetectorResponseFromJSON(json) {
    return StreemApiRunImageDetectorResponseFromJSONTyped(json, false);
}
export function StreemApiRunImageDetectorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detections': !exists(json, 'detections') ? undefined : (json['detections'].map(StreemApiDetectionResultFromJSON)),
    };
}
export function StreemApiRunImageDetectorResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detections': value.detections === undefined ? undefined : (value.detections.map(StreemApiDetectionResultToJSON)),
    };
}
//# sourceMappingURL=StreemApiRunImageDetectorResponse.js.map